import React, { useRef, useState } from 'react';
import styles from './styles';
import PropTypes from 'prop-types';

const SupportInformation = ({ block }) => {
  if (!block) return '';
  const { primary, items } = block;
  const title = primary?.title1;
  const paragraph_mobile = primary?.paragraph_mobile;

  return (
    <>
      <div className='main-container'>
        <div className='section'>
          <h3 className='title'>{title}</h3>

          <div className='paragraph-section-desktop'>
            {items.map((item, i) => {
              return (
                <p className='paragraph'>{item.paragraph_desktop}</p>
              )
            })}
          </div>

          <div className='paragraph-section-mobile'>
            <p className='paragraph'>{paragraph_mobile}</p>
          </div>
        </div>
      </div>

      <style jsx>{styles}</style>
    </>
  );
};
SupportInformation.propTypes = {
  block: PropTypes.shape({
    primary: PropTypes.shape({
      title1: PropTypes.string,
    }),
    items: PropTypes.shape({
      paragraph_desktop: PropTypes.string,
    }),
  }),
};

SupportInformation.defaultProps = {
  block: null,
};

export default SupportInformation;